"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _options = require("./helpers/options");

var _OnChangeProvider = require("../../store/OnChangeProvider");

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Options(props) {
  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var memoizedOnClickHandler = _react["default"].useCallback(function (_ref) {
    var event = _ref.event,
        isDisabled = _ref.isDisabled,
        onClick = _ref.onClick,
        index = _ref.index;
    var stateForClickHandler = {
      options: state.options,
      hasFilter: state.hasFilter,
      isMulti: state.isMulti,
      hasTag: state.hasTag,
      refListBox: state.refListBox,
      refListContainer: state.refListBoxContainer
    };
    (0, _options.handleClickOption)({
      event: event,
      onClick: onClick,
      index: index,
      isDisabled: isDisabled,
      state: stateForClickHandler,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    });
  }, [state.options, state.hasFilter, state.isMulti, state.hasTag, state.refListBox, state.refListBoxContainer, dispatch, onChangeContext]);

  var children = props.children,
      isPopoverOpen = props.isPopoverOpen;
  var index = -1;
  return _react["default"].Children.map(children, function (child) {
    if (child === null) return null;
    var type = child.type.type || child.type;
    var isMulti = state.isMulti,
        hasTag = state.hasTag;
    var _type$displayName = type.displayName,
        displayName = _type$displayName === void 0 ? null : _type$displayName;

    if (type && (0, _options.isWhiteListed)(displayName)) {
      index += 1;
      var isSelected = (0, _options.isOptionSelected)(state, index);

      if (typeof state.options[index] === "undefined" || !(0, _options.isOptionVisible)(state, index)) {
        return null;
      }

      var id = state.options[index].id;
      return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        id: id,
        index: index,
        isPopoverOpen: isPopoverOpen,
        isMulti: isMulti,
        hasTag: hasTag,
        internalHandleOnClick: memoizedOnClickHandler,
        isSelected: isSelected
      }));
    }

    return child;
  });
}

var _default = Options;
exports["default"] = _default;
//# sourceMappingURL=Options.js.map